module.exports = __webpack_public_path__ + "img/Facebook.f8b01b34.png";